import { useContext, useState, useRef, memo } from "react";
import { BrowserContext } from "./services/BrowserContext";
import Overlay from 'react-bootstrap/Overlay';
import ShareModal from "./molecules/modals/ShareModal";

const ContentActionMenu = (props)=>{
    const [showShare, setShowShare] = useState(false);
    const [open, setOpen] = useState(false);
    const toggle = useRef(null);
    const {itemsManipulator} = useContext(BrowserContext);
    const {handleRenameItemName,handleClipboard} = useContext(BrowserContext);

    const deleteItem = function (e) {
        if(window.confirm("Are you sure you want to delete "+props.name+"?")){
            const path = Array.from(props.path);
            path.push(props.name);
            itemsManipulator.delete(path);
        }
    }

    const renameItem = () => handleRenameItemName(props.name)

    const copyItem = function (e) {
        const path=Array.from(props.path);
        path.push(props.name)
        handleClipboard(path,"copy");
    }
    const cutItem = function (e) {
        const path=Array.from(props.path);
        path.push(props.name)
        handleClipboard(path,"cut");
    }

    const download = function() {
        const path=Array.from(props.path);
        path.push(props.name)
        itemsManipulator.download(path);
    }

    const sharePath = [...Array.from(props.path), props.name];

    // Le menu est rendu dans <body> par portail (`container`), et non dans la
    // ligne. Deux raisons, toutes deux dues à la virtualisation :
    // - react-window pose `transform: translateY(...)` sur chaque ligne. Un
    //   élément transformé devient le bloc conteneur de ses descendants en
    //   `position: fixed` : un menu en strategy 'fixed' s'y retrouvait décalé de
    //   l'offset de la ligne (juste sur la 1re, hors écran plus bas).
    // - la liste virtualisée défile en `overflow`, qui rognait un menu en
    //   positionnement absolu.
    // Hors du sous-arbre transformé, ni décalage ni rognage.
    const close = () => setOpen(false);
    // Overlay n'a pas le contexte de Dropdown, qui refermait le menu tout seul
    // au clic sur un item : on le ferme explicitement, avant d'agir pour que les
    // actions bloquantes (confirm) ne le laissent pas ouvert derrière elles.
    const run = (action) => () => { close(); action(); };

    return (
        <>
        <i ref={toggle} className="bi bi-three-dots-vertical" role="button"
           onClick={() => setOpen(value => !value)}>
        </i>

        <Overlay show={open} target={toggle} container={document.body}
                 placement="bottom-start" rootClose onHide={close}>
          {({ placement, arrowProps, show, popper, hasDoneInitialMeasure, ...menuProps }) => (
            <div {...menuProps} className="dropdown-menu show">
              <div className="dropdown-item" onClick={run(download)}>Download</div>
              <div className="dropdown-item" onClick={run(deleteItem)}>Delete</div>
              <div className="dropdown-item" onClick={run(renameItem)}>Rename</div>
              <div className="dropdown-item" onClick={run(copyItem)}>Copy</div>
              <div className="dropdown-item" onClick={run(cutItem)}>Cut</div>
              <div className="dropdown-item" onClick={run(() => setShowShare(true))}>
                  {props.shared ? 'Get link' : 'Share'}
              </div>
            </div>
          )}
        </Overlay>
        {showShare &&
          <ShareModal show={showShare} handleClose={() => setShowShare(false)} path={sharePath} token={props.shareToken} expiresAt={props.shareExpiresAt}/>
        }
        </>
      );
}

export default memo(ContentActionMenu)